export default "__VITE_ASSET__DnfqV7dX__"